var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgeGateIdCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "243px",
    height: "194px",
    viewBox: "0 0 243 194",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 8.52651283e-14,
    y: -7.2475359e-13,
    width: 166.486486,
    height: 117.6,
    rx: 7
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-35.4%",
    y: "-49.3%",
    width: "170.9%",
    height: "200.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.108123779 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 0,
    y: 0,
    width: 47,
    height: 52,
    rx: 4.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path-6",
    cx: 26.4301377,
    cy: 13.0698623,
    r: 13.0698623
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.8%",
    y: "-3.8%",
    width: "107.7%",
    height: "115.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.215062495 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VB--404-Copy-3",
    transform: "translate(-610.000000, -341.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(647.500000, 377.250000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.146508,124.656026 C122.950705,117.533457 125.233664,112.214585 129.995383,108.699411 C137.137962,103.426648 144.912035,104.588028 146.968791,105.006911",
    id: "Path-8",
    stroke: "#30AADE",
    strokeWidth: 4,
    opacity: 0.0992414384,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    transform: "translate(135.051849, 114.628236) rotate(-49.000000) translate(-135.051849, -114.628236) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.148349,116.300201 C142.952546,109.177632 145.235505,103.858761 149.997224,100.343586 C157.139803,95.0708234 164.913876,96.2322036 166.970632,96.6510857",
    id: "Path-8-Copy",
    stroke: "#30AADE",
    strokeWidth: 4,
    opacity: 0.0992414384,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    transform: "translate(155.053690, 106.272412) rotate(79.000000) translate(-155.053690, -106.272412) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.583697,115.070165 C118.676919,104.945376 121.938378,97.346988 128.368075,92.275 C138.012621,84.667018 149.677577,86.4015971 152.6158,87",
    id: "Path-8",
    stroke: "#30AADE",
    strokeWidth: 4,
    opacity: 0.0992414384,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.05167,125.756371 C146.771952,115.581272 150.033321,107.982884 156.835777,102.961206 C167.039462,95.4286879 178.145279,97.0878026 181.083502,97.6862055",
    id: "Path-8-Copy",
    stroke: "#30AADE",
    strokeWidth: 4,
    opacity: 0.0992414384,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    transform: "translate(164.059300, 111.430957) rotate(118.000000) translate(-164.059300, -111.430957) "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.4,0.2 L162.1,0.2 C164.530053,0.2 166.5,2.1699471 166.5,4.6 L166.5,20.7 L166.5,20.7 L0,20.7 L0,4.6 C-2.9759565e-16,2.1699471 1.9699471,0.2 4.4,0.2 Z",
    id: "Rectangle-Copy-7",
    fill: "#506C94"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#506C94",
    opacity: 0.246166138,
    x: 76.6432432,
    y: 41.2,
    width: 73,
    height: 12.6,
    rx: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#506C94",
    opacity: 0.09,
    x: 76.6432432,
    y: 80.7,
    width: 35,
    height: 12.6,
    rx: 1.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(16.643243, 41.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#506C94",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.636458896,
    mask: "url(#mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.003519, 7.759739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D4DBE4",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#D4DBE4",
    fillRule: "evenodd",
    cx: 25.75,
    cy: 41.6104872,
    rx: 25.75,
    ry: 13.0698623
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fill: "#506C94",
    opacity: 0.0873382205,
    x: 76.6432432,
    y: 60.95,
    width: 35,
    height: 12.6,
    rx: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#3B577E",
    strokeWidth: 6,
    strokeLinejoin: "bevel",
    x: 0,
    y: 0,
    width: 166.5,
    height: 117.5,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#506C94",
    opacity: 0.0873382205,
    x: 114.643243,
    y: 60.95,
    width: 35,
    height: 12.6,
    rx: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.53701784,
    y1: 20.7,
    x2: 40.1432432,
    y2: 20.7,
    id: "Path-2",
    stroke: "#3B577E",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51.5370178,
    y1: 20.7,
    x2: 69.5,
    y2: 20.7,
    id: "Path-2",
    stroke: "#3B577E",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.537018,
    y1: 20.7,
    x2: 166.486486,
    y2: 20.7,
    id: "Path-2",
    stroke: "#3B577E",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgeGateIdCard);
export default __webpack_public_path__ + "static/media/age-gate-id-card.52182e2ae3d9a9d50dcafd66a7d90ab1.svg";
export { ForwardRef as ReactComponent };